import { render, staticRenderFns } from "./packetScan.vue?vue&type=template&id=2d6af2bf&scoped=true"
import script from "./packetScan.vue?vue&type=script&lang=js"
export * from "./packetScan.vue?vue&type=script&lang=js"
import style0 from "./packetScan.vue?vue&type=style&index=0&id=2d6af2bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6af2bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6af2bf')) {
      api.createRecord('2d6af2bf', component.options)
    } else {
      api.reload('2d6af2bf', component.options)
    }
    module.hot.accept("./packetScan.vue?vue&type=template&id=2d6af2bf&scoped=true", function () {
      api.rerender('2d6af2bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/packetScan.vue"
export default component.exports